import component from './overview.vue'

export default component
